import { connect } from 'react-redux';

import { sessionDetailsLoaded } from 'redux/modules/sessions/actions/session-details-loaded';

import MarketingScripts from './MarketingScripts';

// Session details will have already been loaded by pre-render actions so we
// need to re-fire the event when impact analytics script is able to handle it
export default connect(null, { onInserted: sessionDetailsLoaded })(MarketingScripts);
